import Link from "next/link";
import dayjs from "dayjs";
import S from "./index.module.scss";
import { FC } from "react";
import { NewsListResourceData } from "@/api/generated-api";
import CustomIcon from "@/components/ui/custom-icon";

const NewsCard: FC<{ news: NewsListResourceData }> = ({ news }) => {
  return (
    <Link key={news.id} className={S.news} href={`/news/${news.id}`}>
      <span className={S.newsTitle}>{news.title}</span>
      <span className={S.newsDescription} dangerouslySetInnerHTML={{ __html: news?.description }} />
      <div className={S.newsBottom}>
        <span className={S.newsDate}>{dayjs(news.date).format("DD MMMM YYYY")}</span>
        <CustomIcon fileName={"icon-arrow-long"} />
      </div>
    </Link>
  );
};

export default NewsCard;
